import { render } from "./VotesResult.vue?vue&type=template&id=6ce1e4ee"
import script from "./VotesResult.vue?vue&type=script&lang=js"
export * from "./VotesResult.vue?vue&type=script&lang=js"
script.render = render

export default script